<template>
  <div class="faq">
    <header-primary
      title="FAQ"
      subtitle="Perguntas frequêntes">
    </header-primary>
    <lazy-load-page v-if="state.main === state.load"></lazy-load-page>
    <error-content-page @handleButton="findFaq" v-if="state.main === state.error"></error-content-page>
    <empty-content-page v-if="state.main === state.empty"></empty-content-page>
    <div v-if="state.main === state.content" class="container pt-5">
      <md-content v-for="(p, i) in perguntasFrenquentes" :key="i" class="bg-transparent md-layout mb-5 md-gutter">
        <balao-pergunta :texto="p.pergunta"
                        :textoResposta="p.resposta" class="md-layout-item md-large-size-50 md-medium-size-50 md-small-size-50 md-xsmall-size-100"></balao-pergunta>
        <balao-resposta :texto="p.resposta" class="md-layout-item mt-2 md-large-size-50 md-medium-size-50 md-small-size-50 md-xsmall-size-100"></balao-resposta>
      </md-content>

      <button-large-light
        sub-titulo="Entre em contato com a VirteX!"
        :link="`/${$route.params.cidade}/contato`"
        titulo="Não encontrou o que desejava?"></button-large-light>
    </div>
  </div>
</template>

<script>
  import HeaderPrimary from "../components/HeaderPrimary";
  import ButtonLargeLight from "../components/ButtonLargeLight";
  import BalaoPergunta from "../components/BalaoPergunta";
  import BalaoResposta from "../components/BalaoResposta";

  import getFaq from '../scripts/getFaq'
  import LazyLoadPage from "../components/LazyLoadPage";
  import ErrorContentPage from "../components/ErrorContentPage";
  import EmptyContentPage from "../components/EmptyContentPage";


  export default {
    name: "Faq",
    components: {
      EmptyContentPage,
      ErrorContentPage, LazyLoadPage, BalaoResposta, BalaoPergunta, ButtonLargeLight, HeaderPrimary},
    data() {
      return {
        perguntasFrenquentes: [],
        state: {
          main: 0,
          load: 0,
          error: 1,
          empty: 2,
          content: 3,
        },
      }
    },
    created() {
      this.findFaq()
    },
    methods: {
      findFaq() {
        let gf = getFaq();

        let { state } = this;

        gf.then(asks => {
          if(asks.length === 0) {
            this.state.main = state.empty;
            return;
          }

          this.state.main = state.content;
          this.perguntasFrenquentes = asks;
        });

        gf.catch(() => {
          this.state.main = state.error;
        })
      }
    }
  }
</script>

<style scoped>

</style>
